var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _rect, _rect2, _g2, _path8, _g3, _circle, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.08682C3.125 7.83682 5.025 7.86182 5.625 9.96182",
    stroke: "url(#paint0_linear_10820_1143)",
    strokeWidth: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10820_1143)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1393 12.9009C12.7976 10.4323 11.0951 8.83157 10.2036 8.42013C10.8208 7.39152 11.0265 7.1858 12.878 7.80296C14.3592 8.2967 14.6765 11.4609 14.6079 12.9009H12.1393Z",
    fill: "url(#paint1_linear_10820_1143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3449 7.75802C13.9906 8.25175 14.4021 11.2553 14.4021 12.6953V14.3411C14.8135 12.901 15.1408 9.86032 13.3735 7.96373C11.2717 5.70827 8.23043 8.37518 6.9961 10.2267C6.00864 11.7079 6.72181 12.7639 7.20182 13.1068H11.1105C9.46477 11.8724 9.32958 10.863 9.46477 10.2267C9.5863 9.65459 10.2877 7.14086 12.3449 7.75802Z",
    fill: "url(#paint2_linear_10820_1143)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3173 12.9869C16.659 10.5182 18.3615 8.91751 19.2529 8.50607C18.6358 7.47746 18.43 7.27174 16.5786 7.8889C15.0974 8.38263 14.78 11.5468 14.8486 12.9869H17.3173Z",
    fill: "url(#paint3_linear_10820_1143)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1117 7.84371C15.4659 8.33744 15.0545 11.341 15.0545 12.781V14.4268C14.643 12.9867 14.3158 9.94602 16.0831 8.04943C18.1848 5.79397 21.2261 8.46087 22.4604 10.3124C23.4479 11.7936 22.7347 12.8496 22.2547 13.1925H18.346C19.9918 11.9581 20.127 10.9487 19.9918 10.3124C19.8702 9.74028 19.1689 7.22655 17.1117 7.84371Z",
    fill: "url(#paint4_linear_10820_1143)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67773 16.7587C5.67773 16.4709 5.91107 16.2375 6.19889 16.2375H22.8486C23.1364 16.2375 23.3697 16.4709 23.3697 16.7587V24.2195C23.3697 25.9465 21.9698 27.3465 20.2428 27.3465H8.80469C7.07772 27.3465 5.67773 25.9465 5.67773 24.2195V16.7587Z",
    fill: "url(#paint5_linear_10820_1143)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10820_1143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 19,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67773 16.759C5.67773 16.4711 5.91107 16.2378 6.19889 16.2378H22.8486C23.1364 16.2378 23.3697 16.4711 23.3697 16.759V24.2198C23.3697 25.9467 21.9698 27.3467 20.2428 27.3467H8.80469C7.07772 27.3467 5.67773 25.9467 5.67773 24.2198V16.759Z",
    fill: "url(#paint6_linear_10820_1143)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10820_1143)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10820_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6576 26.8423C6.86817 26.8423 4.86817 24.8686 4.73659 23.6844C-7.50025 30.0002 13.4208 34.3423 14.9997 34.7371C16.2629 35.0529 24.7366 27.2371 28.8155 23.2897C26.9734 18.9476 23.2892 11.9213 23.2892 18.5528C23.2892 25.1844 19.7213 26.2928 18.9471 26.4476C16.9735 26.8423 14.4474 26.8423 10.6583 26.8423H10.6576Z",
    fill: "#FD741C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_10820_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6576 26.8423C6.86817 26.8423 4.86817 24.8686 4.73659 23.6844C-7.50025 30.0002 13.4208 34.3423 14.9997 34.7371C16.2629 35.0529 24.7366 27.2371 28.8155 23.2897C26.9734 18.9476 23.2892 11.9213 23.2892 18.5528C23.2892 25.1844 19.7213 26.2928 18.9471 26.4476C16.9735 26.8423 14.4474 26.8423 10.6583 26.8423H10.6576Z",
    fill: "#FFFBD4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_10820_1143)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 15.0002,
    width: 32.3684,
    height: 3.15789,
    fill: "#FD772C",
    fillOpacity: 0.56
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.03223,
    y: 12.1233,
    width: 20.9835,
    height: 4.9373,
    rx: 1.04232,
    fill: "#FFDC63"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10820_1143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 12,
    width: 22,
    height: 6
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.03223,
    y: 12.123,
    width: 20.9835,
    height: 4.9373,
    rx: 1.04232,
    fill: "#FFDC63"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10820_1143)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_10820_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07915 9.86816C11.9739 10.9208 16.816 13.0261 13.0265 13.0261C11.1751 13.0261 9.56242 13.4029 8.28968 13.8805C6.95736 14.3804 5.99758 14.9907 5.52652 15.3945C-2.99979 15.0787 -3.02611 13.1576 -1.97348 12.2366L9.07915 9.86816Z",
    fill: "#FFF48E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_10820_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2894 14.2103C22.9736 16.105 9.07889 15.5261 2.7631 15.3945C-7.97374 17.2892 3.42099 20.7892 9.86836 21.7103L29.2105 22.4997L31.1841 16.5787L24.0789 9.86816C23.6842 10.3945 23.6052 12.3155 23.2894 14.2103Z",
    fill: "#FF9E45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_10820_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52624 16.5789C3.6315 16.5789 3.42098 16.0525 3.55256 15.7894C-5.92112 22.421 5.65782 21.7104 12.6315 20.5262H23.2894L26.4473 16.5789C26.1841 15.7894 24.4736 7.10507 24.8683 14.9999C24.8999 15.6307 24.8683 15.9209 24.4736 16.184C18.9473 16.184 7.42098 16.5789 5.52624 16.5789Z",
    fill: "#FFED8D"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7866 17.0605L16.7866 23.6436L14.7294 22.4819L12.6722 23.6436L12.6722 17.0605L16.7866 17.0605Z",
    fill: "url(#paint7_linear_10820_1143)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_10820_1143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.1982,
    y: 12.1233,
    width: 4.9373,
    height: 4.9373,
    transform: "rotate(90 17.1982 12.1233)",
    fill: "url(#paint8_linear_10820_1143)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.18182,
    cy: 6.13641,
    r: 0.681818,
    fill: "#FEE92C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8331 2.30874L15.2135 3.06052L15.9366 3.49312L15.3391 4.08727L15.1511 4.90861L14.4015 4.52403L13.5622 4.59904L13.6963 3.76721L13.3656 2.99224L14.1982 2.86271L14.8331 2.30874Z",
    fill: "#FFB017"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7046 4.09082C21.5796 4.09082 20.8296 4.46583 20.4546 5.69867",
    stroke: "url(#paint9_linear_10820_1143)",
    strokeWidth: 0.95
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10820_1143",
    x: -3.78545,
    y: 11.1301,
    width: 37.3009,
    height: 28.3163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35,
    result: "effect1_foregroundBlur_10820_1143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10820_1143",
    x: -3.78545,
    y: 11.1301,
    width: 37.3009,
    height: 28.3163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35,
    result: "effect1_foregroundBlur_10820_1143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_10820_1143",
    x: -1,
    y: 14.0002,
    width: 34.3687,
    height: 5.15796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_10820_1143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_10820_1143",
    x: -7.44531,
    y: 4.86816,
    width: 26.8633,
    height: 15.5264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_10820_1143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_10820_1143",
    x: -5.05625,
    y: 6.46816,
    width: 39.6403,
    height: 19.4316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7,
    result: "effect1_foregroundBlur_10820_1143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_10820_1143",
    x: -4.32197,
    y: 7.40825,
    width: 35.0692,
    height: 18.1928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15,
    result: "effect1_foregroundBlur_10820_1143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_10820_1143",
    x: 10.7062,
    y: 10.5687,
    width: 8.04659,
    height: 8.04635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.777273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.923665 0 0 0 0 0.558536 0 0 0 0 0.294133 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10820_1143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10820_1143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10820_1143",
    x1: -1.125,
    y1: 9.23799,
    x2: 6.08276,
    y2: 10.3273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109006,
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629471,
    stopColor: "#FFA673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931408,
    stopColor: "#FDDF6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10820_1143",
    x1: 12.4115,
    y1: 8.43701,
    x2: 12.4101,
    y2: 12.9009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10820_1143",
    x1: 9.07869,
    y1: 16.9738,
    x2: 16.9734,
    y2: 5.52641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415435,
    stopColor: "#FFA837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805387,
    stopColor: "#FF7400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10820_1143",
    x1: 17.0451,
    y1: 8.52294,
    x2: 17.0464,
    y2: 12.9869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10820_1143",
    x1: 20.3779,
    y1: 17.0595,
    x2: 12.4831,
    y2: 5.6121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415435,
    stopColor: "#FFA837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805387,
    stopColor: "#FF7400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10820_1143",
    x1: 14.5237,
    y1: 20.1315,
    x2: 14.5237,
    y2: 32.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10820_1143",
    x1: 14.5237,
    y1: 20.1318,
    x2: 14.5237,
    y2: 32.7634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10820_1143",
    x1: 14.9637,
    y1: 15.3948,
    x2: 14.9637,
    y2: 26.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10820_1143",
    x1: 16.9171,
    y1: 14.3108,
    x2: 22.4434,
    y2: 14.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10820_1143",
    x1: 24.9546,
    y1: 5.11172,
    x2: 20.1144,
    y2: 5.71312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109006,
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629471,
    stopColor: "#FFA673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931408,
    stopColor: "#FDDF6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10820_1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8636,
    height: 23.8636,
    fill: "white",
    transform: "translate(2.38623 5.45459)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b0c53defba6133f709254cd048d564d3.svg";
export { ForwardRef as ReactComponent };